import { useEffect, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import { BookingBar, EnquiryModal, defaultSelection } from "../components/BookingWidget";
import Marquee from "../components/Marquee";
import Rooms from "../components/Rooms";
import Gallery from "../components/Gallery";
import Amenities from "../components/Amenities";
import Attractions from "../components/Attractions";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const Home = () => {
  const [selection, setSelection] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = selection ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [selection]);

  const openBooking = (roomId) => setSelection({ ...defaultSelection(), room_type: roomId || "deluxe" });

  return (
    <div className="grain min-h-screen bg-[#0D0B0A] text-[#F5F2EB]" data-testid="home-page">
      <Navbar onBook={() => openBooking()} />
      <Hero onBook={() => openBooking()} />
      <div id="booking" className="relative z-20 mx-auto -mt-24 max-w-6xl px-5 sm:px-8">
        <BookingBar onSearch={setSelection} />
      </div>
      <Marquee />
      <Rooms onReserve={openBooking} />
      <Gallery />
      <Amenities />
      <Attractions />
      <Testimonials />
      <Contact />
      <Footer />
      <AnimatePresence>
        {selection && <EnquiryModal selection={selection} onClose={() => setSelection(null)} />}
      </AnimatePresence>
    </div>
  );
};

export default Home;
